import { useState } from 'react';
import { ExerciseTemplateClient, ExerciseTemplateDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useExerciseTemplateApi = () => {
    const apiClient = new ExerciseTemplateClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: ExerciseTemplateDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createExerciseTemplate(data);
        } catch (err: any) {
            setError(err.message || 'Error creating ExerciseTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: ExerciseTemplateDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateExerciseTemplate(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating ExerciseTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getExerciseTemplateById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching ExerciseTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchExerciseTemplates(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching ExerciseTemplates');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteExerciseTemplate(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting ExerciseTemplate');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};